import { inject } from 'vue';

/**
 * Composable for safe toast notifications
 * Uses the global toast provided by the layout, with proper fallback
 *
 * @returns {Function} showToast - Function to display toast notifications
 */
export function useToast() {
  const showToastGlobal = inject('showToastGlobal', null);

  /**
   * Show a toast notification
   * @param {string} message - The message to display
   * @param {string} type - The type of toast (success, error, warning, info)
   * @param {number} duration - Optional duration in milliseconds
   */
  const showToast = (message, type = 'success', duration = undefined) => {
    if (showToastGlobal && typeof showToastGlobal === 'function') {
      if (duration !== undefined) {
        showToastGlobal(message, type, duration);
      } else {
        showToastGlobal(message, type);
      }
    } else {
      // Fallback to console if toast system is not available
      const prefix = type.toUpperCase();
      console.warn(`[${prefix}] Toast: ${message}`);
    }
  };

  return { showToast };
}
